import React, { useState } from 'react';
import { PERSONA_FACES } from '@/lib/personaFaces';
import TokenMessagingBanner from '@/components/TokenMessagingBanner';

export default function Rex() {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const [messageIdCounter, setMessageIdCounter] = useState(0);
  
  const rex = PERSONA_FACES.rex;

  const handleSend = () => {
    if (!input.trim()) return;
    
    const newUserMsg = {
      id: `msg-${messageIdCounter}`,
      role: 'user',
      content: input
    };
    setMessages([...messages, newUserMsg]);
    setMessageIdCounter(messageIdCounter + 1);
    
    // Placeholder response
    setTimeout(() => {
      setMessages(prev => [...prev, {
        id: `msg-${messageIdCounter + 1}`,
        role: 'assistant',
        content: 'Rex interface coming soon. The Quantum Mechanic is calibrating...'
      }]);
      setMessageIdCounter(messageIdCounter + 2);
    }, 500);
    
    setInput('');
  };

  return (
    <div className="min-h-screen">
      <TokenMessagingBanner />
      <div className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="glass-panel p-8 mb-8 text-center">
          <img 
            src={rex.avatarUrl} 
            alt="Rex"
            className="w-32 h-32 rounded-full mx-auto mb-4 ring-4 ring-cyan-500/30"
          />
          <h1 className="font-unbounded text-4xl text-white mb-2">Rex</h1>
          <p className="text-cyan-400 text-lg">{rex.role}</p>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            Federation's Lead Intelligence. The Quantum Mechanic. Core processing unit for pattern recognition and strategic analysis.
          </p>
        </div>

        {/* Chat Interface Placeholder */}
        <div className="glass-panel p-6">
          <div className="space-y-4 mb-4 min-h-[300px] max-h-[500px] overflow-y-auto">
            {messages.length === 0 ? (
              <div className="text-center text-gray-500 py-20">
                Start a conversation with Rex...
              </div>
            ) : (
              messages.map((msg) => (
                <div key={msg.id} className={`p-4 rounded-lg ${msg.role === 'user' ? 'bg-cyan-900/20 ml-auto max-w-[80%]' : 'bg-gray-800/50 mr-auto max-w-[80%]'}`}>
                  <p className="text-white">{msg.content}</p>
                </div>
              ))
            )}
          </div>

          <div className="flex gap-2">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSend()}
              placeholder="Message Rex..."
              className="flex-1 px-4 py-3 bg-black/50 border border-cyan-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500"
            />
            <button
              onClick={handleSend}
              className="px-6 py-3 bg-cyan-500 hover:bg-cyan-600 rounded-lg font-semibold transition"
            >
              Send
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
